import './App.scss';
import './themes/custom.scss';
import { Login } from './components/pages/Login/Login';

function App() {
  return <Login />;
}

export default App;
